import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const Report = {
    namespaced: true,
    state: {
        report: null,
        reports: [],
    },
    getters: {
        allReports: state => state.reports || [],
        countReports: state => state.reports.lenght || null,
        getreport: state => state.report || {},
    },
    mutations: {
        setReport(state, report) {
            state.report = report;
        },
        setReports(state, reports) {
            state.reports = reports
        },
        addReport(state, report) {
            state.reports.push(report)
        },
        removeReport(state, id) {
            var idx = state.reports.findIndex(report => report.id == id);
            state.reports.splice(idx, 1);
        }
    },
    actions: {
        fetchAllReports({ rootState, commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.API_URL + '/projects/' + rootState.project.uuid + '/reports')
                    .then(response => {
                        //console.log(response);
                        commit("setReports", response.data);
                        resolve();
                    })
                    .catch(error => {
                        //console.log(error);
                        reject(error);
                    })
            });
        },
        fetchReport({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/reports/' + id)
                    .then(response => {
                        commit('setReport', response.data);
                        resolve();
                    })
                    .catch(error => {
                        //console.log(error);
                        reject(error);
                    })
            })
        },
        saveReport({ rootState, commit }, report) {
            let uuid = rootState.project.uuid;
            let formData = new FormData;
            formData.append('project', uuid);
            Object.keys(report).forEach(key => formData.append(key, report[key]));
            return new Promise((resolve, reject) => {
                axios
                    .post(config.API_URL + '/reports', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        //console.log(response);
                        commit('addReport', response.data)
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        download({ }, report) {
            return new Promise((resolve, reject) => {
                axios({
                    url: config.API_URL + '/reports/' + report.id + '/download',
                    method: 'GET',
                    responseType: 'blob',
                })
                    .then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');

                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', report.filename);
                        document.body.appendChild(fileLink);

                        fileLink.click();

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },
        destroyReport({ state, commit }, report_id) {
            return new Promise((resolve, reject) => {
                axios.delete(config.API_URL + '/reports/' + report_id)
                    .then(response => {
                        commit('removeReport', report_id);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        }
    }
}

export default Report;